import axios from 'axios';
import * as apiURL from './apiConfig';

export const postAddress = async (data) => {
  try {
    const response = await axios.post(apiURL.ADDRESS_URL, {
      ...data,
    });
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const getAddresses = async () => {
  try {
    const response = await axios.get(`${apiURL.ADDRESS_URL}?sortBy=-1`);
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const deleteAddress = async (addressId) => {
  try {
    const response = await axios.delete(`${apiURL.ADDRESS_URL}/${addressId}`);
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};

export const editAddress = async ({ formData, id }) => {
  try {
    const response = await axios.put(`${apiURL.ADDRESS_URL}/${id}`, formData);
    return response.data;
  } catch (error) {
    error.handleGlobally && error.handleGlobally();
    throw new Error(error);
  }
};
